import React from "react";
import img1 from "../../../shared/assets/icons/image 12.png";
import { useSelector } from "react-redux";
import Decrypt from "../../../shared/utils/Decrypt";

const VendorDashboardHeader = ({ isSidebarExpanded }) => {
  const { vendorProfileDetails } = useSelector((state) => state.vendorProfile);

  return (
    <div
      className={`flex flex-grow  justify-between items-center max-w-full  p-2 ${
        isSidebarExpanded ? `ml-64 translate-x ` : `ml-14`
      } `}
      style={{
        // background: "var(--dashboard-bg-color)",
        height: "10vh",
      }}
    >
      <div
        className={`flex justify-between items-center w-full text-black ml-2  border-b-2`}
      >
        {/* First Div with User Info */}
        <div className="firstDiv flex items-center">
          <div
            className="m-2 shake-hand"
            style={{ width: "43px", height: "43px" }}
          >
            <img src={img1} alt="User" className="w-full h-full" />
          </div>
          <div className="font-semi text-lg ml-2">
            <h1>{Decrypt(vendorProfileDetails?.ownerName)}</h1>
            <h3 className="text-sm text-gray-500">
              {vendorProfileDetails?.vendorBusinessName}
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorDashboardHeader;
